// @flow

import _ from 'lodash';


// -- utils
import DateUtils from '../../utils/DateUtils';
import Utils from '../../utils/Utils';

// -- constants
import BookingConstants from '../../constants/BookingConstants';

// -- entities
import ApiObject from '../ApiObject';

export default class BookingSettingsSpecific extends ApiObject {

  /**
   * Set by the front
   */
  id: string;// = Utils.generateUID();

  /**
   * The date where the specific takes place.
   */
  date: number;

  /**
   * The period to impact.
   *
   * see BookingConstants.BookingPeriod
   */
  period: number;

  /**
   * The state of the specific.
   *
   * see BookingConstants.State
   */
  state: number = BookingConstants.State.CLOSED;

  getUniqueIdentifier() {
    return this.id;
  }

  postJsonAssignation(data: Object) {
  }

  isClosed(): boolean {
    return this.state === BookingConstants.State.CLOSED;
  }

  isClosedForPeriod(period): boolean {
    return this.isClosed() && this.period === period;
  }

  isImpactingDate(date): boolean {
    const impactedDate = DateUtils.fromMsTimestamp(this.date);

    if (DateUtils.isSameDay(impactedDate, date)) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/booking/BookingSettingsSpecific.js